import { Field } from 'redux-form';
import { TextField } from 'iqvia-shared/components';
import React from 'react';

const IntegerObjectField = ({ name, label, onChange, readonlyForm }) => {
  const handleChange = event => {
    const {
      target: { value },
    } = event;

    if (value === '' || /[.,]/.test(value) || isNaN(Number(value))) {
      event.preventDefault();
      return;
    }

    onChange(value);
  };

  return (
    <Field
      name={`${name}`}
      component={TextField}
      type="number"
      label={label}
      disabled={readonlyForm}
      onChange={handleChange}
    />
  );
};

IntegerObjectField.displayName = 'IntegerObjectField';

export default IntegerObjectField;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectFields/IntegerObjectField.js